// extracted by mini-css-extract-plugin
module.exports = {"infoContainer":"_1dYR5pVRbEU0OWDvrhkZGD","block":"K6PxDbyEqPGE8dK2Pl-mv","blockName":"_1H6fm1QlMsiBxhWt9oHAbf","blockValue":"_3EYdlExSmnzBY7nJKVxvrY"};